<div class="container-fluid py-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
            <h2 class="mb-1">Omnisend Errors</h2>
            <p class="text-muted mb-0">Persistent log of every Omnisend API failure (writes from <code>makeOmnisendApiCall</code>). Newest first.</p>
        </div>
        <div class="d-flex align-items-center gap-3">
            <label class="mb-0 small text-muted">Page size</label>
            <select class="form-select form-select-sm" style="width: 120px"
                    [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="250">250</option>
                <option [ngValue]="500">500</option>
            </select>
        </div>
    </div>

    <div class="card shadow-sm">
        <div class="table-responsive">
            <table class="table table-sm table-hover mb-0 align-middle">
                <thead class="table-light">
                    <tr>
                        <th style="width: 170px">When</th>
                        <th style="width: 70px">Method</th>
                        <th>URL</th>
                        <th style="width: 80px">Status</th>
                        <th>Error</th>
                        <th style="width: 220px">Context</th>
                        <th style="width: 60px"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let row of rows">
                        <tr (click)="toggleRow(row)" style="cursor: pointer">
                            <td class="small text-muted">{{ timestampMoment(row) | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
                            <td><code class="small">{{ row.method }}</code></td>
                            <td class="small text-break">
                                <code>{{ row.url }}</code>
                            </td>
                            <td>
                                <span class="badge" [ngClass]="statusBadgeClass(row.statusCode)">
                                    {{ row.statusCode || '—' }}
                                </span>
                            </td>
                            <td class="small text-danger">{{ row.errorMessage }}</td>
                            <td class="small">
                                <div *ngIf="row.email" class="text-muted">{{ row.email }}</div>
                                <div *ngIf="row.uid" class="text-muted"><code class="text-muted">{{ row.uid }}</code></div>
                                <div *ngIf="row.contactId" class="text-muted">contact: <code>{{ row.contactId }}</code></div>
                            </td>
                            <td>
                                <i class="fa" [ngClass]="row.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </td>
                        </tr>
                        <tr *ngIf="row.expanded">
                            <td colspan="7" class="bg-light">
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between mb-1">
                                            <strong class="small text-muted">Request body</strong>
                                            <button class="btn btn-sm btn-outline-secondary" (click)="copyPayload(row, 'request'); $event.stopPropagation()">
                                                <i class="fa fa-copy"></i> Copy
                                            </button>
                                        </div>
                                        <pre class="small p-2 bg-white border rounded mb-0" style="max-height: 360px; overflow: auto">{{ row.requestBodyPreview || '—' }}</pre>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between mb-1">
                                            <strong class="small text-muted">Response body</strong>
                                            <button class="btn btn-sm btn-outline-secondary" (click)="copyPayload(row, 'response'); $event.stopPropagation()">
                                                <i class="fa fa-copy"></i> Copy
                                            </button>
                                        </div>
                                        <pre class="small p-2 bg-white border rounded mb-0" style="max-height: 360px; overflow: auto">{{ row.responseBody || '—' }}</pre>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="rows.length === 0">
                        <td colspan="7" class="text-center text-muted py-5">
                            No Omnisend errors logged.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
